import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonFullscreenLoaderComponent from 'webapp/components/common/fullscreen-loader';
import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

export default class MetricsLoadingRouteTemplate extends Component {
	@service('navigation') declare navigationService: Service.Navigation;

	<template>
		{{! Company metrics has no section header or side paddings, so it loads like Artifacts and Routines }}
		{{#if this.navigationService.isActivatedRouteCompanyMetrics}}
			<CommonFullscreenLoaderComponent />
		{{else}}
			<SkeletonScreenComponent @type="table" />
		{{/if}}
	</template>
}
